import {login} from "../../redux/user/actions";

import AuthLayout from "../../layouts/AuthLayout";

const Login = () => {
    return <AuthLayout onSubmitAction={login}/>;
};

export default Login;